// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__GGCfm","button":"styles_button__1SA9S"};